import DatesUtils from "../utils/dates";

export default class IncomeService {

  static apiRelativePath = "/incomes"

  constructor(apiClient) {
    this.apiClient = apiClient;
  }

  search = async (start, end, type, category) => {
    return this.apiClient.get(`${IncomeService.apiRelativePath}/search`, {
      start_datetime: DatesUtils.formatDate(start),
      end_datetime: DatesUtils.formatDate(end),
      ...type && {type_id: type},
      ...category && {category_id: category}
    });
  }

  export = async (start, end, type, category) => {
    return this.apiClient.get(`${IncomeService.apiRelativePath}/export`, {
      start_datetime: DatesUtils.formatDate(start),
      end_datetime: DatesUtils.formatDate(end),
      ...type && {type_id: type},
      ...category && {category_id: category}
    });
  }

  create = async (data) => {
    return this.apiClient.post(`${IncomeService.apiRelativePath}`, data);
  }

  patch = async (id, data) => {
    return this.apiClient.patch(`${IncomeService.apiRelativePath}/${id}`, data);
  }

  delete = async (id) => {
    return this.apiClient.delete(`${IncomeService.apiRelativePath}/${id}`);
  }
}
